import { createSlice } from '@reduxjs/toolkit';

const counterSlice = createSlice({
  name: 'counter',
  initialState: { value: 1 },
  reducers: {
    Nextstep: (state) => {
      state.value += 1;
    },
    Prevstep: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
  },
});

export const { Nextstep, Prevstep, incrementByAmount } = counterSlice.actions;
export default counterSlice.reducer;
